// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qtNA","name":"styles_name__1xhdN","phone":"styles_phone__iTJE7"};